import { getVideoMetadata } from "@/app/actions";
import { CustomCategory } from "@/components/category";
import Duration from "@/components/duration";
import TeaserHeading from "@/components/teaser-heading";
import TeaserLinkedContent from "@/components/teaser-linked-content";
import VideoThumbnail from "@/components/video-thumbnail";
import { Content } from "@/services/content/types";
import classNames from "classnames";
import Link from "next/link";
import { use } from "react";

type HorizontalProps = {
  play: Content.Play;
};

const Horizontal = (props: HorizontalProps) => {
  const videoId =
    props.play.fields.quickchannelIds?.[0] || props.play.fields.videos?.[0];

  const videoMetadata = videoId
    ? use(
        getVideoMetadata({
          qbrick: props.play.fields.videos?.[0],
          quickchannel: props.play.fields.quickchannelIds?.[0],
        })
      )
    : null;

  const title = props.play.fields.teaserTitle || props.play.fields.title;
  const image = props.play.fields.teaserImage || props.play.fields.image;
  const playShow = props.play.fields["play-show"];

  const hasLinkedContent = Boolean(props.play.fields.linkedContent?.length);

  return (
    <div>
      <Link
        href={`/play/${props.play.fields.slug}`}
        className="group bg-black-400"
      >
        <div className="grid grid-cols-4" data-mode="dark">
          <div className="p-6 flex h-full bg-black-400 col-span-2 justify-center items-center">
            <div>
              {playShow && (
                <CustomCategory
                  inverted
                  color="Play"
                  name={playShow.fields.title}
                />
              )}

              {title && (
                <TeaserHeading
                  text={title}
                  className="text-4xl text-static-white"
                />
              )}
            </div>
          </div>
          <div
            className={classNames(
              "relative bg-sand-700 col-span-2 aspect-w-16 aspect-h-9"
            )}
          >
            <VideoThumbnail
              fallbackUrl={videoMetadata?.thumbnail}
              thumbnailImage={image}
              className="w-full h-full object-cover"
            />
            <Duration duration={videoMetadata?.duration} centered={false} />
          </div>
        </div>
      </Link>
      {hasLinkedContent && (
        <TeaserLinkedContent
          linkedContent={props.play.fields.linkedContent}
          showLinkedContent={hasLinkedContent}
          compactMode={false}
        />
      )}
    </div>
  );
};

export default Horizontal;
